<script>
import {approvalApi} from "@/api/chemical";
import UtDescriptions from "@/components/UtDescriptions.vue";
import {formatImage} from "@/utils/format";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name: 'ChemicalApprovalDetail',
  components: {UtDescriptions,ElImageViewer},
  // 或者通过$route对象接收
  created() {
    this.id = this.$route.params.id; // 对应params传递方式
  },
  data() {
    return {
      id: null,
      approval: {},
      imageViewer: {
        show: false,
        list: []
      },
      descColumn: 3,
      auditVisible: false,
      auditForm : {},
      modifyContent : null,
      baseConfig: [
        { label: '设备编码(唯一)', prop: 'deviceCode' },
        { label: '审批类型', prop: 'approvalTypeDesc' },
        { label: '审批状态', prop: 'statusDesc' },
        { label: '申请备注', prop: 'comment' },
        { label: '审批人', prop: 'approvalByName' },
        { label: '审批结果类型', prop: 'resultTypeDesc' },
        { label: '审批结果信息', prop: 'message' },
        { label: '审批时间', prop: 'approvalTime' },
        { label: '创建时间', prop: 'createTime' },
        { label: '创建人', prop: 'createByName' },
      ],
      deviceConfig: [
        { label: '设备编码(唯一)', prop: 'deviceCode' },
        { label: '设备类型', prop: 'deviceTypeName' },
        { label: '设备总容量(千克)', prop: 'totalCapacity' },
        { label: '设备名称', prop: 'deviceName' },
        { label: '存储物料类型', prop: 'materialTypeDesc' },
        { label: '仓管员', prop: 'managerIdName' },
        { label: '仓管员联系电话', prop: 'managerPhone' },
        { label: '资质文件', prop: 'qualificationFile' },
        { label: '设备存放地址', prop: 'deviceAddress' }
      ],
      locationConfig: [
        { label: '库位类型', prop: 'locationTypeDesc' },
        { label: '存储物料类型ID', prop: 'materialTypeDesc' },
        { label: '库位容量(千克)', prop: 'capacity' },
      ],
      layerConfig: [
        { label: '分层序号', prop: 'layerNo' },
        { label: '物料类型', prop: 'materialTypeDesc' },
      ]
    }
  },
  mounted() {
    this.fetchApprovalDetail()
  },
  methods: {
    async fetchApprovalDetail() {
      const { result } = await approvalApi.detailApprovalById(this.id)
      this.approval = result
      if (result.approvalType === 'MODIFY'){
        this.modifyContent = result.content;
        this.descColumn = 2
      }
    },
    back() {
      this.$router.back();
    },
    closeImageViewer() {
      this.imageViewer.show = false
    },
    viewFiles(value) {
      // 实现文件预览逻辑
      this.imageViewer.list = value.qualificationFile.map(item => formatImage(item))
      this.imageViewer.show = true
    },
    openAudit(){
      this.auditVisible = true;
    },
    async handleSubmit(){
      console.log('submit audit data', this.auditForm)
      this.auditForm.id = this.approval.id
      const res  =  await approvalApi.auditApproval(this.auditForm)
      if (res.code === '0000'){
        this.$message.success('审批成功')
        this.auditVisible = false
        this.fetchApprovalDetail()
      }
    }
  },
}

</script>

<template>
<div>
  <el-card>
    <template #header>
      <div style="display: flex; align-items: center; justify-content: space-between">
        <div style="display: flex; align-items: center; gap: 12px;">
          <el-button type="primary" size="small" @click="back" icon="el-icon-arrow-left">返回</el-button>
          <span>审批详情</span>
        </div>

        <el-button type="warning" size="small" @click="openAudit" v-if="approval.status === 'CREATED'">审批</el-button>
      </div>
    </template>
    <ut-descriptions :config="baseConfig" :data="approval"  title="基础信息" column="3"/>

    <div style="content: '' ; height: 10px;" />

    <div style="display: flex; gap: 30px;">
      <div class="device-info">
        <ut-descriptions :config="deviceConfig" :data="approval.deviceInfo" title="设备信息" :column="descColumn">
          <template #qualificationFile="{row}">
            <span class="file-text-btn" @click="viewFiles(row)">点击查看</span>
          </template>
        </ut-descriptions>

        <el-card shadow="never" :body-style="{padding: '8px'}" >
          <template v-for="location in  approval.deviceInfo.locations">
            <ut-descriptions :config="locationConfig" :data="location" :title="`库位-${location.locationNo}`" theme="light" size="mini" :column="descColumn" />
            <el-card shadow="never" :body-style="{padding: '8px'}" style="border: none">
              <template v-for="layer in location.layers">
                <ut-descriptions :config="layerConfig" :data="layer" :column="2" size="mini" />
              </template>
            </el-card>
          </template>
        </el-card>
      </div>

      <div class="device-info" v-if="modifyContent">
        <ut-descriptions :config="deviceConfig" :data="modifyContent" title="（修改的）设备信息" :column="descColumn">
          <template #qualificationFile="{row}">
            <span class="file-text-btn" @click="viewFiles(row)">点击查看</span>
          </template>
        </ut-descriptions>

        <el-card shadow="never" :body-style="{padding: '8px'}" >
          <template v-for="location in  modifyContent.locations">
            <ut-descriptions :config="locationConfig" :data="location" :title="`库位-${location.locationNo}`" theme="light" size="mini" :column="descColumn" />
            <el-card shadow="never" :body-style="{padding: '8px'}" style="border: none">
              <template v-for="layer in location.layers">
                <ut-descriptions :config="layerConfig" :data="layer" :column="2" size="mini" />
              </template>
            </el-card>
          </template>
        </el-card>
      </div>
    </div>
  </el-card>
  <!-- 图片预览弹窗组件 -->
  <ElImageViewer
      v-if="imageViewer.show"
      :url-list="imageViewer.list"
      :on-close="closeImageViewer"
  />

  <el-dialog :visible.sync="auditVisible" title="审批" width="500px">
    <el-form label-width="80px">
      <el-form-item label="审批结果">
        <el-radio-group v-model="auditForm.resultType">
          <el-radio-button label="SUCCESS">通过</el-radio-button>
          <el-radio-button label="FAIL">拒绝</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审批信息">
        <el-input v-model="auditForm.message" placeholder="请输入审批结果信息" type="textarea" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSubmit">提交</el-button>
        <el-button @click="auditVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<style scoped>
.file-text-btn {
  font-size: 14px;
  color: #0f7ae5;
  cursor: pointer;
  text-decoration: underline; /* 添加下划线 */
}
.device-info{
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1
}
</style>
